"use client";

import { type RefObject, useLayoutEffect, useState } from "react";

export function usePipPortalHost(
	stageRef: RefObject<HTMLElement | null>,
	portalToStage: boolean,
): HTMLElement | null {
	const [host, setHost] = useState<HTMLElement | null>(() =>
		portalToStage ? stageRef.current : null,
	);

	useLayoutEffect(() => {
		if (!portalToStage) {
			setHost(null);
			return;
		}

		const sync = () => {
			const next = stageRef.current;
			setHost((current) => (current === next ? current : next));
		};

		sync();

		const element = stageRef.current;
		if (!element || typeof ResizeObserver === "undefined") {
			return;
		}

		const observer = new ResizeObserver(sync);
		observer.observe(element);
		return () => observer.disconnect();
	}, [portalToStage, stageRef]);

	return portalToStage ? host : null;
}
